var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-criticality-card',{attrs:{"title":"Sağlık Raporu","fields":_vm.fields,"provider":_vm.provider,"enabled-levels":_vm.enabledLevels,"excel-file-name":"Saglik_Raporu"}})}
var staticRenderFns = []

export { render, staticRenderFns }